import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceId/projects/$channelId/docs")({
	component: DocsPage,
});

function DocsPage() {
	return <div>Docs Page</div>;
}
